//
import Service from '@/services/api/service'
import CustomerModel from '@/models/Sale/SlCustomer'

//
import filters from './filters'
import headers from './headers'

//
export default class extends Service {

    //
    static filters  = filters
    static headers  = headers
    static includes = [
        'pch_payment_condition',
        'sl_ground_seller.hr_employee',
    ]
    
    //
    static model = CustomerModel
}
